export const oneSignalInit = function (config) {
    window.OneSignal = window.OneSignal || [];
    if (mustOneSignalInit(config)) {
        OneSignal.push(function () {
            let settings = {
                appId: config.oneSignalAppId,
                notifyButton: {
                    enable: false,
                },
                welcomeNotification: {
                    disable: true,
                },
            };
            if (!isHttps(config))
                settings.subdomainName = config.initOneSignal;
            if (config.safariWebId)
                settings.safari_web_id = config.safariWebId;

            OneSignal.init(settings);

            if (isHttps(config))
                OneSignal.showNativePrompt();
        });
    }
};

export const mustOneSignalInit = (config) => {
    return config.oneSignalAppId && config.initOneSignal;
};

export const isHttps = (config) => {
    return config.initOneSignal === "https";
};
